import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import "./HeaderRight.css";
import { Link } from "react-router-dom";

function HeaderRight() {
  
  return (
    <div className="Header-right">
      <button>
        <Link to="/SignIn" style={{textDecoration:'none',color:'white' }}> Sign in </Link>

        {/* <span style={{ marginLeft: "10px" }}>
          <FontAwesomeIcon icon={faShoppingCart} />
          {getTotalCartItems() !== 0 && <span>{getTotalCartItems()}</span>}
        </span> */}
      </button>
      <button>
      <Link to="/SignUp" style={{textDecoration:'none',color:'white' }}> Sign Up </Link>
        {/* <span style={{ marginLeft: "10px" }}>
          <FontAwesomeIcon icon={faShoppingCart} />
          {getTotalCartItems() !== 0 && <span>{getTotalCartItems()}</span>}
        </span> */}
      </button>
    </div>
  );
}

export default HeaderRight;
